import type { ModalFuncProps } from "antd";
import type { ReactNode } from "react";

export type AdminConfirmConfig = {
  title: ReactNode;
  content?: ReactNode | undefined;
  okText?: ReactNode | undefined;
  cancelText?: ReactNode | undefined;
  okDanger?: boolean | undefined;
  onOk?: (() => void) | undefined;
};

type AdminModalApi = {
  confirm: (config: ModalFuncProps) => unknown;
};

export function openAdminConfirm(modal: AdminModalApi, config: AdminConfirmConfig) {
  const modalConfig: ModalFuncProps = {
    title: config.title,
    ...(config.content !== undefined ? { content: config.content } : {}),
    ...(config.okText !== undefined ? { okText: config.okText } : {}),
    ...(config.cancelText !== undefined ? { cancelText: config.cancelText } : {}),
    ...(config.okDanger ? { okButtonProps: { color: "danger", variant: "solid" } } : {}),
    ...(config.onOk ? { onOk: config.onOk } : {}),
  };
  modal.confirm(modalConfig);
}
